import { render } from "./UsersDataChart.vue?vue&type=template&id=093bf43e&ts=true"
import script from "./UsersDataChart.vue?vue&type=script&lang=ts"
export * from "./UsersDataChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__